import { HttpClient } from '@zeta-core';
import { APIResponse, IEmptyRequestResponse } from '@zeta-types';
import { AI_INTERACTION_SERVICE } from '../services-path';
import {
  IChatRequest,
  IMarkChatRequest,
  IMarkChatRequest2,
  IMergeClientDataRequest,
  IPatchAIInteractionSectionRequest,
  IProcessTrackerResponse,
  IRegisterProspectRequest,
  IRegisterProspectResponse,
  ISessionsChatResponse,
  IStartNewChatRequest,
  IStartNewChatResponse,
  ISyncClientDataRequest,
  ISyncClientDataResponse,
  IViewClientDataSummaryResponse,
  IViewTrackProgressRequest,
  IViewTrackProgressResponse,
} from './types';

export * from './types';

export const AIInteractionService = () => {
  return {
    registerProspect: (payload: IRegisterProspectRequest): APIResponse<IRegisterProspectResponse> =>
      HttpClient.post(`${AI_INTERACTION_SERVICE}/client_data/register_prospect_client`, payload),

    syncClientData: (payload: ISyncClientDataRequest): APIResponse<ISyncClientDataResponse> =>
      HttpClient.post(`${AI_INTERACTION_SERVICE}/client_data/sync_client_data`, payload),

    viewClientData: (clientId: string): APIResponse<ISyncClientDataResponse> => HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/by_client/${clientId}`),

    patchClientData: (payload: IPatchAIInteractionSectionRequest): APIResponse<ISyncClientDataResponse> =>
      HttpClient.patch(`${AI_INTERACTION_SERVICE}/client_data/`, payload),

    captureChat: (payload: IChatRequest) => HttpClient.post(`${AI_INTERACTION_SERVICE}/chat/chat`, payload),

    markChat: (payload: IMarkChatRequest) => HttpClient.post(`${AI_INTERACTION_SERVICE}/chat/mark`, payload),
    markChat2: (payload: IMarkChatRequest2) => HttpClient.post(`${AI_INTERACTION_SERVICE}/chat/mark_2`, payload),

    viewChatSessionsByClient: ({ client_id }: { client_id: string }): APIResponse<ISessionsChatResponse> =>
      HttpClient.get(`${AI_INTERACTION_SERVICE}/chat_sessions/client/${client_id}`),
    viewChatSessionsByUserSession: (): APIResponse<ISessionsChatResponse> => HttpClient.get(`${AI_INTERACTION_SERVICE}/chat_sessions/user/sessions`),

    viewChatSessions: ({ sessionId }: { sessionId: string }): APIResponse<ISessionsChatResponse> =>
      HttpClient.get(`${AI_INTERACTION_SERVICE}/chat_sessions/${sessionId}`),

    updateChatSessionName: ({ session_name, session_id }: { session_name: string; session_id: string }) =>
      HttpClient.patch(`${AI_INTERACTION_SERVICE}/chat_sessions/${session_id}`, { session_name }),

    AIInteractionService: (session_id: string) => HttpClient.delete(`${AI_INTERACTION_SERVICE}/chat_sessions/${session_id}`),

    viewCheckList: ({ clientId }: { clientId: string }) => HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/check_list/${clientId}`),
    updateCheckList: ({ clientId, payload }: { clientId: string }) => HttpClient.patch(`${AI_INTERACTION_SERVICE}/client_data/check_list/${clientId}`, payload),

    viewClientSummary: (clientId: string): APIResponse<IViewClientDataSummaryResponse> =>
      HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/summary/${clientId}`),

    updateFactFindDeclaration: (clientId: string) => HttpClient.patch(`${AI_INTERACTION_SERVICE}/client_data/declaration/${clientId}`),
    viewFactFindDeclaration: (clientId: string) => HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/declaration/${clientId}`),
    mark2Status: (clientId: string) => HttpClient.post(`${AI_INTERACTION_SERVICE}/chat/mark_2_status`, { client_id: clientId }),
    viewClientTrackers: (clientId: string) => HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/client/tracker/${clientId}`),
    viewProcessTracker: (processId: string): APIResponse<IProcessTrackerResponse> =>
      HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/tracker/${processId}`),

    // for agentic chat

    getChatSessionsByAdvisorId: ({ advisorId }: { advisorId: string }): APIResponse<ISessionsChatResponse[]> =>
      HttpClient.get(`${AI_INTERACTION_SERVICE}/chat_sessions/advisor/${advisorId}`),

    startNewChat: (payload: IStartNewChatRequest): APIResponse<IStartNewChatResponse> =>
      HttpClient.post(`${AI_INTERACTION_SERVICE}/chat/market_analysis`, payload),

    checkFactFindMandatoryFields: (clientId: string) => HttpClient.get(`${AI_INTERACTION_SERVICE}/client_data/check/mandatory_fields/${clientId}`),

    getUserChatSessions: (payload: { client_id?: string; advisor_id?: string }): APIResponse<ISessionsChatResponse> =>
      HttpClient.post(`${AI_INTERACTION_SERVICE}/chat_sessions/user/sessions`, payload),

    viewTrackProgress: (payload: IViewTrackProgressRequest): APIResponse<IViewTrackProgressResponse> =>
      HttpClient.post(`${AI_INTERACTION_SERVICE}/track/progress`, payload),

    mergeClientData: (payload: IMergeClientDataRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${AI_INTERACTION_SERVICE}/client_data/merge_client_data`, payload),
  };
};
